/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'tc-client-common';
import * as consts from '../../const.js';
import { hideModal, deleteDocumentError } from '../../actions/actions';
import Loading from '../../components/loading/loading.component';
import Notification from '../common/notification/notification.component';

const DeleteAddendumModalContent = ({ close, addendum, refreshDocuments, deleteAddendum }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reason, setReason] = useState('');
  const emptyReason = reason.trim() === '';
  const addendumName = addendum.name;

  const updateReason = (e) => {
    setError(false);
    setReason(e.target.value);
  };

  return (
    <div>
      {loading && <Loading />}
      <br />
      {error && <Notification type="error" data={consts.DELETE_ADDENDUM_ERROR_MESSAGE} />}
      <p className="modal-details" title>
        <i className="material-icons description-icon">insert_drive_file</i>
        {consts.ADDENDUM} {addendumName}
      </p>
      <div className="form-group">
        <label htmlFor="reason" className="control-label">
          {consts.DELETE_ADDENDUM_REASON} <span>*</span>
        </label>
        <textarea
          disabled={loading}
          required
          id="reason"
          className="form-control"
          value={reason}
          onChange={updateReason}
        />
      </div>

      <div className="edit-modal-footer">
        <hr className="edit-modal-divider" />
        <Button
          id="delete-document-cancel-button"
          type="reset"
          theme="default large-button"
          handleClick={close}
          label={consts.CANCEL_BTN}
          disabled={loading}
        />
        <Button
          id="delete-document-button"
          theme="secondary large-button"
          label={consts.DELETE_BTN}
          disabled={loading || emptyReason}
          handleClick={() => {
            setLoading(true);
            setError(false);
            deleteAddendum({ addendum, reason })
              .then(() => {
                setLoading(false);
                refreshDocuments();
                close();
              })
              .catch(() => {
                setLoading(false);
                setError(true);
              });
          }}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addendum: ownProps.props.addendum,
    refreshDocuments: ownProps.props.refreshDocuments,
    deleteAddendum: ownProps.props.deleteAddendum,
    close: () => {
      dispatch(deleteDocumentError(null));
      dispatch(hideModal());
    }
  };
};

export default connect(null, mapDispatchToProps)(DeleteAddendumModalContent);
